import reducer from "./reducers";
import * as galleryActions from "./actions";

export { galleryActions };
export default reducer;
